import React, { Fragment } from 'react';
import { connect } from '../../redux/store';
import { compose } from 'recompose';
import { FormCard } from '../shared/FormCard';
import { PageTitle } from '../shared/PageTitle';
import { EmptyMessage, Utils, C } from '@kineticdata/bundle-common';
import { List } from 'immutable';

const FavoritesComponent = props => {
  return (
    <Fragment>
      <div className="page-container">
        <div className="page-panel">
          <PageTitle parts={['Favorites']} title="Favorites" />
          {props.favorites && (
            <div className="cards">
              {props.favorites
                .map(form => ({
                  form,
                  path: `${props.appLocation}/forms/${form.slug}`,
                  key: form.slug,
                }))
                .map(props => <FormCard {...props} />)}
            </div>
          )}
          {(!props.favorites || props.favorites.size === 0) && (
            <EmptyMessage title="You do not have any favorite services" />
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state, props) => ({
  kappSlug: state.app.kapp.slug,
  appLocation: state.app.location,
  favorites: List(
    Utils.getProfileAttributeValues(
      state.app.profile,
      C.ATTRIBUTE_USER_PROFILE_FAVORITES,
    ),
  )
    .map(slug => (state.app.kapp.forms || []).find(form => form.slug === slug))
    .filter(Boolean)
    .sortBy(form => form.name),
});

export const Favorites = compose(connect(mapStateToProps))(FavoritesComponent);
